import React from "react";
import { Button } from "@mui/material";

import { Progress } from "ui";

import { useCustomWorkflow } from "fond/hooks/useCustomWorkflow";
import { Project, WORKFLOW_KEYS } from "fond/types";

const stageConfig: Record<string, { label: string }> = {
  analyze: { label: "Preprocessing network data" },
  design: { label: "Running network solver" },
};

interface SolvePanelProps {
  project: Project;
  versionId: string;
  readOnly: boolean;
}

const SolvePanel: React.FC<SolvePanelProps> = ({ versionId, readOnly }) => {
  const { workflowState, stages, runWorkflow } = useCustomWorkflow({
    versionId,
    key: WORKFLOW_KEYS.ISG.SOLVE,
  });

  const isInProgress = workflowState === "STARTING" || workflowState === "IN_PROGRESS";

  return (
    <>
      {stages && (isInProgress || workflowState === "ERROR") && (
        <Progress steps={stages.map(({ key, status }) => ({ ID: key, Label: stageConfig[key]?.label ?? key, Status: status }))} />
      )}

      {!isInProgress && (
        <Button
          fullWidth
          variant="contained"
          size="small"
          sx={{ mt: stages ? 2 : 0 }}
          disabled={!runWorkflow || isInProgress || readOnly}
          onClick={() => runWorkflow?.()}
        >
          {workflowState === "COMPLETE" ? "Rerun Solve" : "Run Solve"}
        </Button>
      )}
    </>
  );
};

export default SolvePanel;
